<div class="idle">
	<div class="top-bar">
		<img src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png" class="logo" />
		<div class="ms-4 my-auto text h1 welcome-message">Welcome to {{ posService.venueService.ooVenue.name }}</div>
		<div class="ms-auto my-auto text h1">{{ moment(clockTime).format("hh:mma") }}</div>
	</div>
	<div class="body">
		<div class="d-flex">
			<div class="access-code-pad">
				<app-pos-login></app-pos-login>
			</div>
		</div>
	</div>
</div>
